import { Component, Inject, OnDestroy, OnInit, Input } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { JobsOffer } from '../../models/jobs-offer';
import { Status } from '../../models/user-profile';
import { OfferStore } from '../state/offer.store';
import { Observable } from 'rxjs/Observable';

enum PageType {None, Next, Prev}

@Component({
  selector: 'app-slider-cv',
  templateUrl: './slider-cv.component.html',
  styleUrls: ['./slider-cv.component.css']
})
export class SliderCvComponent implements OnInit, OnDestroy {

  jobInvited: JobsOffer;

  offerList:any;
  currentIndex:number = 0;
  maxIndex:number;
  userId:string;
  job:JobsOffer;
  sub: any;
  type: PageType = PageType.None;
  loading: Observable<boolean>;
  size: Observable<number>;
  filters: any;

  constructor(public dialogRef: MdDialogRef<SliderCvComponent>,
              public offerStore: OfferStore,
              @Inject(MD_DIALOG_DATA) public data: any) {
    this.size = this.offerStore.offers.map((offers: JobsOffer[]) => offers.length);
  }

  ngOnInit() {
    this.sub = this.offerStore.offers.subscribe(jobs => {
      this.offerList = jobs;
      this.maxIndex = jobs.length;

      if(this.type === PageType.None) {
        this.currentIndex = this.data.selected;
      } else if(this.type === PageType.Next) {
        this.currentIndex = 0;
      } else if(this.type === PageType.Prev) {
        this.currentIndex = this.maxIndex - 1;
      }

      if (this.data.jobInvited) {
        this.jobInvited = this.data.jobInvited;
      }

      this.userId = this.offerList[this.currentIndex].user.id;
      this.job = this.offerList[this.currentIndex].job;
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  nextCV() {
    this.currentIndex++;
    if(this.currentIndex >= this.maxIndex) {
      this.currentIndex = 0;
      this.type = PageType.Next;
      this.offerStore.nextPage(this.data.requirement, this.jobInvited);
    } else {
      this.userId = this.offerList[this.currentIndex].user.id;
      this.job = this.offerList[this.currentIndex].job;
    }
  }

  prevCV() {
    this.currentIndex--;
    if(this.currentIndex < 0) {
      this.currentIndex = 0;
      this.type = PageType.Prev;
      this.offerStore.prevPage(this.data.requirement, this.jobInvited);
    } else {
      this.userId = this.offerList[this.currentIndex].user.id;
      this.job = this.offerList[this.currentIndex].job;
    }
  }

  onStatusChanged(event:Status) {
    this.offerList[this.currentIndex].status = event;
  }

  onFavoriteChanged(event:boolean) {
    this.offerList[this.currentIndex].favorite = event;
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/slider-cv/slider-cv.component.ts